import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectAllEntities} from '@ngneat/elf-entities';

import {containersStore} from '@store/settings/containers/containers.store';

export const getContainersDataSource = createRequestDataSource({
  store: containersStore,
  data$: () => containersStore.pipe(selectAllEntities()),
  requestKey: 'getContainers',
  dataKey: 'containers',
});